<section >

  <app-navbar></app-navbar>

      <body>
        <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active">
                  <img src="assets/Image/Carrussel/costura2.jpg" class="d-block w-100" height="864" alt="costura">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/inatec-14.jpeg" class="d-block w-100" height="864" alt="electronica">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/computacion.jpg" class="d-block w-100" height="864" alt="computacion">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/LAB.jpg" class="d-block w-100" height="864" alt="protagonista">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/inatec-15.jpeg" class="d-block w-100" height="864" alt="electricidad">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/computacion2.jpg" class="d-block w-100" height="864" alt="computacion">
              </div>
              <div class="carousel-item">
                <img src="assets/Image/Carrussel/costura.jpg" class="d-block w-100" height="864" alt="costura">
              </div>
            </div>
          </div>
      </body>

      <app-foot></app-foot>

</section>
